import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ToastItem } from '../../types/ToastItem';

interface Props {
    config: ToastItem;
    onDismissHandler: () => void;
}

export default function AlertSuccessToast({ config, onDismissHandler }: Props) {
    return (
        <Snackbar
            open={true}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            autoHideDuration={config.autoHide}
            onClose={onDismissHandler}
        >
            <Alert severity="success">
                <Grid container direction="row" wrap="nowrap" alignItems="center">
                    <Grid item xs={true}>
                        <Typography variant="body2">{config.text}</Typography>
                    </Grid>
                    <Grid item xs="auto">
                        <Tooltip title="Close">
                            <IconButton onClick={onDismissHandler} size="large">
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Alert>
        </Snackbar>
    );
}
